<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">Carl Scholz is an American architect and amateur historian with an international background. He was born and raised in Chile, to where his grandparents had emigrated from Germany in the 1880s. His professional practice was based in California. He travelled widely and is fluent in English, Spanish and German. Currently he is working on another novel and a collection of short stories. Carl lives in the San Francisco Bay Area.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6b08ca04